import React from "react";
import { ChevronRight } from "lucide-react";

// Liste de raccourcis (onglets Activité / Messages).
export default function PriceHubPanel({ title, subtitle, items, testid }) {
  return (
    <div className="mt-6 animate-in fade-in slide-in-from-bottom-2 duration-300" data-testid={testid}>
      <h1 className="font-[Outfit] text-[28px] font-black leading-tight">{title}</h1>
      {subtitle && <p className="mt-1 text-[13px] font-medium text-foreground/65">{subtitle}</p>}
      <div className="mt-5 space-y-3">
        {items.filter(Boolean).map((it) => (
          <button
            key={it.testid}
            type="button"
            onClick={it.onClick}
            className="street-press flex w-full items-center gap-3 rounded-3xl bg-white p-4 text-left street-border street-shadow-sm"
            data-testid={it.testid}
          >
            <div className={`relative grid h-11 w-11 flex-none place-items-center rounded-2xl street-border-thin ${it.tone || "bg-accent"}`}>
              {it.icon}
              {Number(it.badge || 0) > 0 && (
                <span className="absolute -right-1.5 -top-1.5 grid h-5 min-w-5 place-items-center rounded-full bg-primary px-1 text-[10px] font-black text-primary-foreground street-border-thin">
                  {it.badge}
                </span>
              )}
            </div>
            <div className="min-w-0 flex-1">
              <div className="font-[Outfit] text-[15px] font-black leading-tight">{it.label}</div>
              {it.sub && <div className="mt-0.5 truncate text-[12px] font-medium text-foreground/60">{it.sub}</div>}
            </div>
            <ChevronRight className="h-5 w-5 flex-none text-foreground/40" />
          </button>
        ))}
      </div>
    </div>
  );
}
